module.exports = __webpack_public_path__ + "img/pic3.1c5fface.png";